import { render, staticRenderFns } from "./officialChoose.vue?vue&type=template&id=da829576&scoped=true"
import script from "./officialChoose.vue?vue&type=script&lang=js"
export * from "./officialChoose.vue?vue&type=script&lang=js"
import style0 from "./officialChoose.vue?vue&type=style&index=0&id=da829576&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da829576",
  null
  
)

export default component.exports